import { createAction } from 'redux-actions';

import types from './types';

const initialize = createAction(types.INITIALIZE);
const toggleExpandedStockInfo = createAction(types.TOGGLE_EXPANDED_STOCK_INFO);
const productStockRequest = createAction(types.PRODUCT_STOCK_REQUEST);
const productsStockRequest = createAction(types.PRODUCTS_STOCK_REQUEST);
const productStockResponseSuccess = createAction(types.PRODUCT_STOCK_RESPONSE_SUCCESS);
const productsStockResponseSuccess = createAction(
    types.PRODUCTS_STOCK_RESPONSE_SUCCESS,
    stores => ({ stores }),
);
const productStockResponseFailure = createAction(types.PRODUCT_STOCK_RESPONSE_FAILURE);
const setErrorMessage = createAction(types.SET_RTS_ERROR_MESSAGE);

const setInCart = createAction(types.SET_IN_CART);
const setDeliveryStore = createAction(types.SET_DELIVERY_STORE);
const showProductStock = createAction(types.SHOW_PRODUCT_STOCK);
const autoLoadProductStock = createAction(types.AUTO_LOAD_PRODUCT_STOCK);
const showCartStock = createAction(types.SHOW_CART_STOCK);
const setLastStoreData = createAction(types.SET_LAST_STORE_DATA);
const setLastStoreIsUsed = createAction(types.SET_LAST_STORE_IS_USED);

const toggleStockInfoList = createAction(types.TOGGLE_STOCK_INFO_LIST);
const resetErrors = createAction(types.RESET_RTS_ERRORS);
const saveStoreName = createAction(types.SAVE_STORE_NAME);
const navigateAndShowCartStock = createAction(types.NAVIGATE_AND_SHOW_CART_STOCK);

const clearStores = createAction(types.CLEAR_STORES);
const clearErrorType = createAction(types.CLEAR_ERROR);
const setInStockInLastStore = createAction(types.SET_IN_STOCK_IN_LAST_STORE);
const productStockRequestLatestStore = createAction(types.LATEST_STORE_PRODUCT_STOCK_REQUEST);
const setDeliveryInformation = createAction(types.DELIVERY_INFORMATION);

export default {
    initialize,
    toggleExpandedStockInfo,
    productStockRequest,
    productsStockRequest,
    productStockRequestLatestStore,
    productStockResponseSuccess,
    productsStockResponseSuccess,
    productStockResponseFailure,
    setInCart,
    setDeliveryStore,
    showProductStock,
    autoLoadProductStock,
    showCartStock,
    setLastStoreData,
    setLastStoreIsUsed,
    toggleStockInfoList,
    resetErrors,
    saveStoreName,
    navigateAndShowCartStock,
    clearStores,
    clearErrorType,
    setInStockInLastStore,
    setErrorMessage,
    setDeliveryInformation,
};
